import { IScenarioSplitItem as IPlacementMarginScenarioSplitItem } from '@AMIEWEB/MarginTool/Components/PayPackage/AddScenario/model';

export enum PlacementMarginStatusTransitionModalType {
  None,
  Approve,
  Deny,
  RequestApproval,
  Verify,
  Reset,
}

export enum PlacementMarginPayPackageField {
  NewStatus = 'newStatus',
  RejectReasons = 'rejectReasons',
  OtherReasons = 'otherReasons',
  DueDate = 'dueDate',
  AssignedTo = 'assignedTo',
  CC = 'cc',
  Attachments = 'attachments',
  AdditionalDetails = 'additionalDetails',
}

export enum PlacementMarginPayPackageStatus {
  Pending = 1,
  ApprovalRequested = 2,
  Approved = 3,
  Verified = 4,
}

export enum PlacementMarginStatusTransitionButtons {
  Approve = 'APPROVE',
  RequestApproval = 'REQUEST APPROVAL',
  Deny = 'DENY',
  reset = 'RESET',
  verify = 'VERIFY',
}

export enum PlacementMarginScenarioStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
}

export interface IPlacementMarginPayPackageStatusTransitionModalDetails {
  openModal: boolean;
  type: PlacementMarginStatusTransitionModalType;
}

export interface IInitiatePlacementMarginPayPacketStatusTransition
  extends IPlacementMarginPayPackageStatusTransitionModalDetails {
  statusId?: number;
}

export interface IPlacementMarginStatusOptions {
  id: number;
  name: string;
  description: string;
  rejectionReasons: IPlacementMarginStatusOptions[] | null;
}

export interface IPlacementMarginPayPackageStatus {
  payPackageStatusTransitionModalDetails: IPlacementMarginPayPackageStatusTransitionModalDetails;
  payPackageStatusOptions: IPlacementMarginStatusOptions[];
  recentStatusUpdatedScenarioId?: number;
  isEmailModalOpen: IPlacementMarginEmailModalType;
  emailRecipients: IPlacementMarginEmailRecipientModal;
}

export interface IPlacementMarginEmailModalType {
  openEmailModal: boolean;
  emailType: string;
  emailVariant?: string;
}

export interface IUpdatePlacementMarginPayPackageStatusPayload {
  statusId: number;
  payPackageId: number;
  placementId: number;
  bookingPeriodId: number;
  notes?: string;
  userId: number;
  openEmailModal?: boolean;
  timestamp?: string;
  bookingPeriodStartDate?: Date | string;
  bookingPeriodEndDate?: Date | string;
  scenarioSplitItemList?: IPlacementMarginScenarioSplitItem[];
}

export interface IDeletePlacementMarginScenarioDetailsPayload {
  scenarioId: number;
  timestamp?: string;
}

export interface IDeletePlacementMarginToolDetailsPayload {
  placementId: number;
}

export interface IPlacementMarginEmail {
  firstName: string;
  lastName: string;
  employeeId: number;
  email: string;
}

export interface IPlacementMarginEmailRecipientModal {
  recruiterDirector: IPlacementMarginEmail;
  recruiter: IPlacementMarginEmail;
  accountManager: IPlacementMarginEmail;
  candidateContract: IPlacementMarginEmail;
  clientContractAdmin: IPlacementMarginEmail;
  propelApprovers: IPlacementMarginEmail;
  divisionId: number;
  division: string;
}

export interface IPlacementMarginEmailSenderModal {
  name: string;
  email: string;
  senderId: string;
  userId: string;
  editFlag?: boolean;
}
